import { isEmpty, omit } from 'lodash';

import { AddressFormFeatures, FrozenFieldsAfterPrefill, Recipient } from 'api/api';

/**
 * TODO: right now frozen/prefilled address is used by Storelens for email input only
 * In the future you could add additional fields
 */

export const prepareNewAddress = (features?: AddressFormFeatures, prefill?: Recipient) => {
  return {
    ...(features?.frozen_fields_after_prefill?.fields?.includes('email') &&
      prefill?.email && { email: prefill.email }),
  };
};

export const isDeliveryAddressEmpty = (
  address: Recipient,
  frozenFields: FrozenFieldsAfterPrefill['fields'] = []
) => {
  return isEmpty(omit(address, frozenFields));
};
